export function numberSorter(a: Record<string, any>, b: Record<string, any>, dataIndex: string) {
    const valA = parseFloat(a[dataIndex] ?? "0") || 0
    const valB = parseFloat(b[dataIndex] ?? "0") || 0
    return valA - valB
}

export function textSorter(a: Record<string, any>, b: Record<string, any>, dataIndex: string) {
    const valA = (a[dataIndex] ?? "").toString().toLowerCase()
    const valB = (b[dataIndex] ?? "").toString().toLowerCase()
    return valA.localeCompare(valB)
}
